import {Injectable} from '@angular/core';
import {Response, Headers, RequestOptions} from '@angular/http';
import {HttpAuth} from './http-auth.service';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {Enterprise} from '../models/enterprise';
import 'rxjs/add/operator/map';

@Injectable()
export class EnterpriseService {
    private enterpriseUrl: string = `${ environment.apiRoot }/company/`;

    constructor(private http: HttpAuth) { }

    public getEnterpriseByNit(nit): Observable<any> {
        const params: URLSearchParams = new URLSearchParams();
        params.append('nit', String(nit));

        const options = new RequestOptions({search: params});

        return this.http.get(this.enterpriseUrl+"?nit="+nit, options)
          .map(this.extractData)
          .catch(this.handleError);
    }

    //noinspection JSMethodCanBeStatic
    private extractData(res: Response) {
        let body = res.json();

        return body.data || {};
    }

    //noinspection JSMethodCanBeStatic
    private handleError(error: Response | any) {
        let errMsg: string;

        if (error instanceof Response) {
            const body = error.json() || '';
            const err = body.meta && body.meta.message || JSON.stringify(body);
            errMsg = `${err}`;
        } else {
            errMsg = error.message ? error.message : error.toString();
        }

        console.error(errMsg);

        return Observable.throw(errMsg);
    }
}


// WEBPACK FOOTER //
// /Users/everis/code/Dj/front.staff/src/app/services/enterprise.service.ts